import * as React from 'react';

import { Avatar } from '@rematter/ui-web';

import { AccountRecord } from '../../_graphql/queryAccountsByIds';

import { LabeledText } from './LabeledText';
import { SalesOrderTabCustomerSectionInfo } from './SalesOrderTabCustomerSectionInfo';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type Props = {
  selectedAccount: AccountRecord;
};

export const SalesOrderTabCustomerSectionContacts: React.FC<Props> = ({
  selectedAccount,
}) => {
  const t = useTranslations();
  const contacts = selectedAccount?.contacts ?? [];

  return (
    <SalesOrderTabCustomerSectionInfo
      className="@SalesOrderTabCustomerSectionContacts"
      title={t.salesOrderDetail.customer.sections.contacts}
    >
      {contacts.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8">
          <p className="text-sm text-neutral/50">
            {t.salesOrderDetail.customer.noContacts}
          </p>
        </div>
      ) : (
        contacts.map((contact) => (
          <div
            className="mt-4 flex flex-row items-center gap-4"
            key={contact.id}
          >
            <div className="flex w-[356px] flex-row items-center gap-[10px]">
              <Avatar name={contact.fullName} size="xl" />
              <div className="flex flex-col">
                <LabeledText label="Contact" text={contact.fullName} />
                {contact.isPrimary && (
                  <span className="text-xs font-medium text-primary-darker">
                    {t.salesOrderDetail.customer.primaryContact}
                  </span>
                )}
              </div>
            </div>
            <span className="w-[356px] text-primary">
              {contact.phone || '-'}
            </span>
            <span className="w-[356px] text-primary">
              {contact.email || '-'}
            </span>
          </div>
        ))
      )}
    </SalesOrderTabCustomerSectionInfo>
  );
};
